import { Box, Grid, SxProps, Theme, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getDateString, getRoundName } from "../common/RoundHelper";
import { PoolXNumberFormat } from "../common/CurrencyFormatter";
import { Syndicate } from "../models/syndicate";
import { Link } from 'react-router-dom'
import { GetFlexNumber, GetMixMaxFlex, gradientsC, IsLeo, IsOrangeLight, IsVideo, productNamesC, themeC, UsePoolXLogoInRoundList } from "../theme/themehelper";
import { ShallowRound } from "../models/round";
import kung8 from '../images/kung8.png';
import kung12 from '../images/kung12.png';
import kung13 from '../images/kung13.png';
import video8back from '../images/video_8_background.png';
import video12back from '../images/video_12_background.png';
import video13back from '../images/video_13_background.png';
import video8 from '../images/video8_no_background.png';
import video12 from '../images/video12_no_background.png';
import video13 from '../images/video13_no_background.png';
import mrvegas8 from '../images/mrvegas_8_small.png';
import mrvegas12 from '../images/mrvegas_12_small.png';
import mrvegas13 from '../images/mrvegas_13_small.png';
import mega8 from '../images/mega_8_small.png';
import mega12 from '../images/mega_12_small.png';
import mega13 from '../images/mega_13_small.png';
import comeon8 from '../images/comeon_8.png';
import comeon12 from '../images/comeon_12.png';
import comeon13 from '../images/comeon_13.png';
import comeon7 from '../images/comeon_7.png';
import comeon9 from '../images/comeon_9.png';
import snabbare7 from '../images/snabbare_7.png';
import snabbare9 from '../images/snabbare_9.png';
import snabbare8 from '../images/snabbare_8.png';
import snabbare12 from '../images/snabbare_12.png';
import snabbare13 from '../images/snabbare_13.png';
import reviantBg from '../images/reviant.png';
import hajper8 from '../images/hajper_8.png';
import hajper12 from '../images/hajper_12.png';
import hajper13 from '../images/hajper_13.png';
import stugan8 from '../images/stugan_8.png';
import stugan7 from '../images/stugan_7.png';
import stugan9 from '../images/stugan_9.png';
import stugan12 from '../images/stugan_12.png';
import stugan13 from '../images/stugan_13.png';
import hard13 from '../images/hard_13.png';
import hard12 from '../images/hard_12.png';
import hard8 from '../images/hard_8.png';
import hard9 from '../images/hard_hockey_9.png';

import { DbetEightIcon, DbetEightLadder, DbetHockeyNineLogo, DbetSevenIcon, DbetSixIcon, DbetThirteenIcon, DbetThirteenLadder, DbetTwelveIcon, DbetTwelveLadder } from "../images/dbeticons";

function SyndicateListItem({ syndicate, round, theme, isTerminal }: { syndicate: Syndicate, round: ShallowRound, theme: string, isTerminal: boolean }) {

    const { t } = useTranslation();
    const dateString = getDateString(round, t);
    const { totalAmountPerShare } = syndicate || {};
    const { amount, currency } = totalAmountPerShare || {};
    const isSmallScreen = useMediaQuery('(max-width: 620px)');

    let locale = t('locale');
    const nf = PoolXNumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    let formattedStakePerShare = nf.format(amount);

    if (syndicate === undefined || (syndicate.coupon === undefined && !syndicate.couponHidden)) {
        return (<></>);
    }

    let borderWidth = "1px";

    let smallText: SxProps<Theme> = {
        fontSize: "14px",
        color: 'var(--text-black)',
        fontWeight: "400",
        fontFamily: 'var(--font-body)',
        margin: "0px"
    };

    let smallTextValues: SxProps<Theme> = {
        fontSize: "14px",
        color: 'var(--text-black)',
        lineHeight: "21px",
        fontWeight: "400",
        fontFamily: 'var(--font-body)',
    };

    let smallTitleUpper: SxProps<Theme> = {
        fontSize: isSmallScreen ? "16px" : "20px",
        color: 'var(--text-black)',
        fontWeight: "700",
        fontFamily: 'var(--font-title)',
        textTransform: 'uppercase',
        paddingLeft: '10px',
        paddingRight: '10px',
        maxWidth: isSmallScreen ? '200px' : "auto",
        minWidth: isSmallScreen ? '100px' : "auto",
        textWrap: isSmallScreen ? "wrap" : 'nowrap',
        textAlign: isSmallScreen ? "center" : 'left',
    };

    let stakeStyle: SxProps<Theme> = {
        fontSize: isSmallScreen ? "16px" : "20px",
        color: 'var(--text-black)',
        fontWeight: "700",
        fontFamily: 'var(--font-title)',
        textTransform: 'uppercase',
        textWrap: isSmallScreen ? "wrap" : 'nowrap',
        textAlign: isSmallScreen ? "center" : 'left'
    };

    let button: SxProps<Theme> = {
        marginTop: '10px',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: '25px',
        paddingRight: '25px',
        gap: '4px',
        color: 'var(--button-text-color)',
        height: '32px',
        textTransform: 'var(--text-transform-button)',
        fontWeight: 'var(--font-weight-button)',
        fontSize: '12px',
        lineHeight: '18px',
        border: borderWidth + ' solid #DADADA',
        borderRadius: '5px',
        backgroundColor: "var(--button-color)",
        "&:hover": {
            backgroundColor: "var(--button-hover-color)",
            border: borderWidth + ' solid #DADADA',
        }
    }

    let mixMaxFlexStyle: SxProps<Theme> = {
        fontSize: "14px",
        fontFamily: 'var(--font-title)',
        color: 'var(--text-white)',
        fontWeight: '400',
        textTransform: "uppercase",
        marginTop: "5px"
    }

    let logo = "";
    let gradient = 'linear-gradient(335deg,#A8301F,#FA9547,#D09C72,#B74D01)';

    let roundName = getRoundName(round, t);
    let border = "";
    let boxShadow = "rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px";

    let mixMaxFlex = "";
    let number = GetFlexNumber(round.name);
    let logoWidth = "100px";
    let minMaxFlexTextColor = 'var(--text-white)';
    let numberBackgroundHeight = "64px";
    let numberBackgroundWidth = "77px";
    let numberImage = "";
    let fontFamily = 'var(--font-title)';
    let numberIcon = <></>;
    let logoHeight = "auto";
    let backgroundPosition = "auto";


    if (theme === themeC.Kung) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: "#78C4F8",
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
            margin: '8px'
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#FFF',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };

        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        number = GetFlexNumber(round.name);
        gradient = gradientsC.Kung.Flex;
        logoWidth = "100%";
        numberImage = kung8;
        minMaxFlexTextColor = "#27FFAA";
        numberBackgroundHeight = "61px";
        numberBackgroundWidth = "46px";

        button.border = "none";

        if (round.name.indexOf("Max") > -1) {
            number = "13";
            gradient = gradientsC.Kung.Max;
            numberImage = kung13;
            minMaxFlexTextColor = "#34C2FF";
            numberBackgroundHeight = "64px";
            numberBackgroundWidth = "77px";
        }

        if (round.name.indexOf("Mix") > -1) {
            number = "12";
            gradient = gradientsC.Kung.Mix;
            numberImage = kung12;
            minMaxFlexTextColor = "#EE8DFF";
            numberBackgroundHeight = "62px";
            numberBackgroundWidth = "77px";
        }

        numberImage = `url(${numberImage})`;
        border = "";
    }

    if (theme === themeC.Dbet) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: "#5E5E5E",
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#232323',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };

        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        number = GetFlexNumber(round.name);
        gradient = gradientsC.Dbet.Flex;
        logoWidth = "100%";
        numberImage = "";
        minMaxFlexTextColor = "#F4C004";
        numberBackgroundHeight = "auto";
        numberBackgroundWidth = "110px";
        fontFamily = "Righteous";

        numberIcon =
            <Grid container direction="row" alignItems="center">
                <Grid sx={{ marginRight: "3.5px", paddingLeft: "38px" }}>
                    {DbetEightIcon(34.5, 26)}
                </Grid>
                {DbetEightLadder(14.25, 8.4)}
            </Grid>

        button.border = "none";

        if (round.name.indexOf("Survivor6") > -1) {
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "3.5px", paddingLeft: "38px" }}>
                        {DbetSixIcon(34.5, 26)}
                    </Grid>
                    {DbetEightLadder(14.25, 8.4)}
                </Grid>
        }

        if (round.name.indexOf("Hockey7") > -1) {
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "3.5px", paddingLeft: "38px" }}>
                        {DbetSevenIcon(34.5, 26)}
                    </Grid>
                    {DbetEightLadder(14.25, 8.4)}
                </Grid>
        }

        if (round.name.indexOf("Hockey9") > -1) {
            mixMaxFlex = "";
            numberBackgroundWidth = "105px";
            numberIcon =
                <Grid container alignItems="center" justifyContent="center">
                    {DbetHockeyNineLogo(12, 105)}
                </Grid>
        }

        if (round.name.indexOf("Max") > -1) {
            number = "13";
            gradient = gradientsC.Dbet.Max;
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "3.5px", paddingLeft: "30px" }}>
                        {DbetThirteenIcon(34.5, 41.3)}
                    </Grid>
                    {DbetThirteenLadder(14.25, 8.4)}
                </Grid>
        }

        if (round.name.indexOf("Mix") > -1) {
            number = "12";
            gradient = gradientsC.Dbet.Mix;
            numberIcon =
                <Grid container direction="row" alignItems="center">
                    <Grid sx={{ marginRight: "3.5px", paddingLeft: "30px" }}>
                        {DbetTwelveIcon(34.5, 42.7)}
                    </Grid>
                    {DbetTwelveLadder(14.25, 8.4)}
                </Grid>
        }

        numberImage = `url(${numberImage})`;
        border = "";
    }

    if (theme === themeC.Video) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: "#7E7E7E",
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#FFF',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };

        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        gradient = `url(${video8back})`;
        logo = "";
        numberImage = `url(${video8})`;
        minMaxFlexTextColor = "#7EFFB2";
        button.border = "none";
        logoWidth = "100%";
        fontFamily = "Tilt Warp";
        numberBackgroundWidth = "110px";

        if (round.name.indexOf("Max") > -1) {
            minMaxFlexTextColor = "#FFF3B7";
            numberImage = `url(${video13})`;
            gradient = `url(${video13back})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            minMaxFlexTextColor = "#D47EDD";
            numberImage = `url(${video12})`;
            gradient = `url(${video12back})`;
        }

        border = "";
    }

    if (theme === themeC.MrVegas) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: "#8AD798",
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
            margin: '8px'
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#FFF',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };

        mixMaxFlex = "";
        gradient = "";
        logo = `url(${mrvegas8})`;
        button.border = "none";
        logoWidth = "90px";

        if (round.name.indexOf("Max") > -1) {
            logo = `url(${mrvegas13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            logo = `url(${mrvegas12})`;
        }

        border = "";
    }

    if (theme === themeC.Mega) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: 'var(--font-color-supportive)',
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
            margin: '8px'
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#FFF',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };

        mixMaxFlex = "";
        gradient = "";
        logo = `url(${mega8})`;
        button.border = "none";
        logoWidth = "100px";

        if (round.name.indexOf("Max") > -1) {
            logo = `url(${mega13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            logo = `url(${mega12})`;
        }

        border = "";
    }

    if (theme === themeC.Orange) {
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
        gradient = gradientsC.Orange.Flex;
        logoWidth = "100px";
        boxShadow = "0px 1px 3px 0px #00000040";

        if (roundName.indexOf("13") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
        }

        if (roundName.indexOf("12") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
        }

        border = "";
    }

    if (theme === themeC.GoGo) {
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
        gradient = gradientsC.GoGo.Flex;
        logoWidth = "100px";
        boxShadow = "0px 1px 3px 0px #00000040";

        if (roundName.indexOf("13") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
        }

        if (roundName.indexOf("12") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
        }

        border = "";
    }

    if (theme === themeC.Wood) {
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
        gradient = gradientsC.Wood.Flex;
        logoWidth = "100px";
        boxShadow = "0px 1px 3px 0px #00000040";

        if (roundName.indexOf("13") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
        }

        if (roundName.indexOf("12") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
        }

        border = "";
    }

    if (theme === themeC.Lion) {
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
        gradient = gradientsC.Lion.Flex;
        logoWidth = "100px";
        boxShadow = "0px 1px 13px -2px rgba(16, 24, 40, 0.08)";
        smallTitleUpper.fontSize = "14px";
        smallTitleUpper.fontFamily = "'Roboto'";
        smallTitleUpper.fontWeight = "400";
        smallTitleUpper.textTransform = "none";
        stakeStyle.fontSize = "14px";
        stakeStyle.fontFamily = "'Roboto'";
        stakeStyle.fontWeight = "700";
        stakeStyle.textTransform = "none";

        if (roundName.indexOf("13") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
        }

        if (roundName.indexOf("12") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
        }

        border = "";
    }

    if (theme === themeC.Green) {
        mixMaxFlex = "Matcher";
        gradient = 'none';
        logoWidth = "100px";
        boxShadow = "0px 1px 3px 0px #00000040";
        mixMaxFlexStyle.fontFamily = 'UnibetPro';
        mixMaxFlexStyle.fontSize = '20px';

        if (roundName.indexOf("13") > -1) {
            mixMaxFlex = "Matcher";
            number = "13";
        }

        if (roundName.indexOf("12") > -1) {
            mixMaxFlex = "Matcher";
            number = "12";
        }

        border = "";
    }

    if (theme === themeC.ComeOn) {
        mixMaxFlex = "";
        number = "";
        logo = `url(${comeon8})`;
        logoWidth = "100px";
        logoHeight = "100px";
        boxShadow = "0px 1px 3px 0px #00000040";
        smallTitleUpper.fontFamily = 'Gravity';
        smallTitleUpper.textTransform = "none";
        smallTitleUpper.fontWeight = 400;
        mixMaxFlexStyle.fontFamily = 'Gravity';
        mixMaxFlexStyle.fontSize = '18px';
        backgroundPosition = "-67.5px"

        if (round.name.indexOf("7") > -1) {
            logo = `url(${comeon7})`;
        }
        if (round.name.indexOf("9") > -1) {
            logo = `url(${comeon9})`;
        }
        if (roundName.indexOf("13") > -1) {
            logo = `url(${comeon13})`;
        }

        if (roundName.indexOf("12") > -1) {
            logo = `url(${comeon12})`;
        }

        border = "";
    }

    if (theme === themeC.Hajper) {
        mixMaxFlex = "";
        logo = `url(${hajper8})`;
        logoWidth = "100px";
        logoHeight = "60px";
        boxShadow = "0px 1px 3px 0px #00000040";
        smallTitleUpper.fontFamily = 'HajperDisplay';
        mixMaxFlexStyle.fontFamily = 'HajperDisplay';

        if (roundName.indexOf("13") > -1) {
            number = "13";
            logo = `url(${hajper13})`
        }

        if (roundName.indexOf("12") > -1) {
            number = "12";
            logo = `url(${hajper12})`
        }

        border = "";
    }

    if (theme === themeC.Snabbare) {
        mixMaxFlex = "";
        number = "";
        logo = `url(${snabbare8})`;
        logoWidth = "90px";
        logoHeight = "80px";
        boxShadow = "0px 1px 3px 0px #00000040";
        backgroundPosition = "-88px"


        if (round.name.indexOf("7") > -1) {
            logo = `url(${snabbare7})`;
        }
        if (round.name.indexOf("9") > -1) {
            logo = `url(${snabbare9})`;
        }

        if (roundName.indexOf("13") > -1) {
            logo = `url(${snabbare13})`;
        }

        if (roundName.indexOf("12") > -1) {
            logo = `url(${snabbare12})`;
        }

        border = "";
    }

    if (theme === themeC.Reviant) {
        logo = `url(${reviantBg})`;
        logoWidth = "90px";
        logoHeight = "80px";
        boxShadow = "0px 1px 3px 0px #00000040";
        backgroundPosition = "-88px";
        mixMaxFlex = productNamesC.ComeOn.Flex;
        mixMaxFlexStyle.color = "#E71F00";

        if (roundName.indexOf("13") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Max;
            number = "13";
        }

        if (roundName.indexOf("12") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Mix;
            number = "12";
        }

        border = "";
    }

    if (theme === themeC.Lyllo) {
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.ComeOn.Hockey : productNamesC.ComeOn.Flex;
        gradient = gradientsC.Lyllo.Flex;
        logoWidth = "100px";
        boxShadow = "0px 1px 3px 0px #00000040";

        if (roundName.indexOf("13") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Max;
            number = "13";
        }

        if (roundName.indexOf("12") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Mix;
            number = "12";
        }

        border = "";
    }

    if (theme === themeC.Stugan) {
        mixMaxFlex = "";
        number = "";
        logo = `url(${stugan8})`;
        logoWidth = "96px";
        boxShadow = "0px 1px 3px 0px #00000040";
        logoHeight = "80px";
        backgroundPosition = "-47px"

        if (roundName.indexOf("7") > -1) {
            logo = `url(${stugan7})`;
        }
        if (roundName.indexOf("9") > -1) {
            logo = `url(${stugan9})`;
        }
        if (roundName.indexOf("13") > -1) {
            logo = `url(${stugan13})`;
        }

        if (roundName.indexOf("12") > -1) {
            logo = `url(${stugan12})`;
        }

        border = "";
    }

    if (theme === themeC.Kryss) {
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Paf.Hockey : productNamesC.Paf.Flex;
        gradient = gradientsC.Kryss.Flex;
        logoWidth = "100px";
        boxShadow = "0px 1px 3px 0px #00000040";

        if (roundName.indexOf("13") > -1) {
            mixMaxFlex = productNamesC.Paf.Max;
            number = "13";
        }

        if (roundName.indexOf("12") > -1) {
            mixMaxFlex = productNamesC.Paf.Mix;
            number = "12";
        }

        border = "";
    }

    if (theme === themeC.Hard) {
        mixMaxFlex = "";
        number = "";
        gradient = round.name.indexOf("Hockey") > -1 ? `url(${hard9})` : `url(${hard8})`;
        logoWidth = "100px";
        boxShadow = "0px 1px 3px 0px #00000040";
        smallText.color = "var(--text-white)";
        smallTextValues.color = "var(--text-white)";
        stakeStyle.color = "var(--text-white)";
        smallTitleUpper.color = "var(--text-white)";

        if (roundName.indexOf("13") > -1) {
            gradient = `url(${hard13})`;
        }

        if (roundName.indexOf("12") > -1) {
            gradient = `url(${hard12})`;
        }

        border = "";
    }

    let icon: JSX.Element = <></>;
    
    let hideMenu = "";

    if (isTerminal)
        hideMenu = "?hideMenu=true";

    if (theme === themeC.Orange) {
        const isSurvivor = round.name.indexOf("Survivor") > -1;
        const isLight = IsOrangeLight(theme);
        const orangeCardContent = (
            <div style={{
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '48px',
                background: isLight
                    ? (isSurvivor ? 'linear-gradient(90deg, #FFF0E0 31.86%, #FFFFFF 100%)' : '#FFFFFF')
                    : (isSurvivor ? 'linear-gradient(90deg, #241D15 0%, #1E1E1E 30%)' : '#1E1E1E'),
                border: isSurvivor ? '1px solid #FE8000' : isLight ? '1px solid #DDDDDD' : '1px solid #575757',
                boxShadow: '0px 1px 13px -2px rgba(16, 24, 40, 0.08)',
                borderRadius: '8px',
                overflow: 'hidden',
            }}>
                {/* Ribbon tag */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '8px 12px',
                    width: '104px',
                    minWidth: '104px',
                    height: '48px',
                    background: '#FE8000',
                    borderRadius: '8px 0px 0px 8px',
                }}>
                    <span style={{
                        fontFamily: "'Hind'",
                        fontWeight: 700,
                        fontSize: '12px',
                        lineHeight: '16px',
                        textTransform: 'uppercase',
                        color: '#1F1F1F',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                    }}>
                        {mixMaxFlex} {number}
                    </span>
                </div>

                {/* Content card */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 0px 8px 12px',
                    gap: '8px',
                    flex: 1,
                    height: '48px',
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', flex: 1 }}>
                        <span style={{
                            fontFamily: "'Hind'",
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '20px',
                            color: isLight ? '#1F1F1F' : '#F0F0F0',
                        }}>
                            {syndicate.name}
                        </span>
                        <span style={{
                            fontFamily: "'Hind'",
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '20px',
                            color: isLight ? '#636363' : '#B3B3B3',
                        }}>
                            {dateString}
                        </span>
                    </div>

                    {/* Stake */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '1px', padding: '0px 8px', flexShrink: 0 }}>
                        <span style={{ fontFamily: "'Hind'", fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: isLight ? '#636363' : '#B3B3B3' }}>
                            {t('stake')}:
                        </span>
                        <span style={{ fontFamily: "'Hind'", fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: isLight ? '#1F1F1F' : '#F0F0F0' }}>
                            {formattedStakePerShare}
                        </span>
                    </div>

                    {/* Arrow */}
                    <div style={{ padding: '0px 8px', display: 'flex', alignItems: 'center' }}>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                            <path d="M1 1L6 6L1 11" stroke={isLight ? '#1F1F1F' : '#F0F0F0'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
            </div>
        );

        const linkTo = `/syndicate/${syndicate.id}` + hideMenu;

        if (isTerminal) {
            return <div style={{ marginTop: '8px' }}>{orangeCardContent}</div>;
        }

        return (
            <Link to={linkTo} style={{ textDecoration: 'none' }}>
                <div style={{ marginTop: '8px' }}>
                    {orangeCardContent}
                </div>
            </Link>
        );
    }

    return (
        <Grid container flexWrap="nowrap" direction='row' alignItems={(theme === themeC.GoGo || theme === themeC.Wood || theme === themeC.Orange || theme === themeC.Lion) ? "stretch" : "center"} component={Link} to={`/syndicate/${syndicate.id}` + hideMenu} sx={{
            width: "100%",
            border: (theme === themeC.Lion || IsOrangeLight(theme)) ? '1px solid #DDDDDD' : theme === themeC.Orange ? '1px solid #575757' : border,
            borderRadius: theme === themeC.Lion ? '8px' : 'var(--radius)',
            background: theme === themeC.Lion ? '#FFFFFF' : 'var(--list-boxes-primary)',
            backgroundOrigin: "border-box",
            backgroundClip: "padding-box, border-box",
            padding: "0px",
            margin: "10px",
            minHeight: isSmallScreen ? "90px" : "",
            ...((theme === themeC.GoGo || theme === themeC.Wood || theme === themeC.Orange) && { height: '80px' }),
            ...(theme === themeC.Lion && { height: '48px', minHeight: '48px' }),
            textDecoration: 'none',
            boxShadow: boxShadow,
            overflow: 'hidden',
            ...(theme === themeC.Green && {
                '&:hover': { backgroundColor: '#F5FFFA' },
            }),
        }}>

            {(theme === themeC.GoGo || theme === themeC.Wood || theme === themeC.Orange || theme === themeC.Lion) ? (
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '8px 12px',
                    width: '104px',
                    minWidth: '104px',
                    alignSelf: 'stretch',
                    background: theme === themeC.Lion ? '#FD5C3C' : theme === themeC.Orange ? '#FE8000' : `linear-gradient(90deg, rgba(${theme === themeC.GoGo ? '37,37,37' : '30,30,30'},0.76) 0%, rgba(${theme === themeC.GoGo ? '37,37,37' : '30,30,30'},0.24) 100%), ${theme === themeC.GoGo ? '#F14AA7' : '#B19661'}`,
                    borderRadius: theme === themeC.Lion ? '8px 0px 0px 8px' : 'var(--radius) 0px 0px var(--radius)',
                }}>
                    <span style={{
                        fontFamily: theme === themeC.Lion ? "'Roboto'" : theme === themeC.GoGo ? "'Poppins'" : theme === themeC.Orange ? "'Hind'" : "'GT-America'",
                        fontWeight: 700,
                        fontSize: '12px',
                        lineHeight: '16px',
                        textTransform: 'uppercase',
                        color: (theme === themeC.Orange || theme === themeC.Lion) ? '#1F1F1F' : '#F0F0F0',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                    }}>
                        {mixMaxFlex} {number}
                    </span>
                </div>
            ) : theme === themeC.Green ? (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100px',
                minWidth: '100px',
                height: '100%',
                minHeight: '50px',
                background: '#147B45',
                borderRadius: '4px 0px 0px 4px',
                gap: '2px',
            }}>
                <Typography sx={{
                    fontFamily: 'UnibetPro',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '32px',
                    lineHeight: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'center',
                    color: '#FFFFFF',
                }}>
                    {number}
                </Typography>
                <Typography sx={{
                    fontFamily: 'UnibetPro',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '10px',
                    lineHeight: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'center',
                    color: '#FFFFFF',
                    textTransform: 'uppercase',
                }}>
                    {mixMaxFlex}
                </Typography>
            </Box>
            ) : (
            <Grid container direction='column' sx={{
                width: "120px",
                backgroundImage: gradient,
                height: "100%",
                backgroundSize: "cover",
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: "var(--radius)"

            }}>
                <Grid item sx={{
                    width: logoWidth,
                    height: logoHeight,
                    backgroundImage: logo,
                    backgroundSize: 'cover',
                    backgroundPositionX: backgroundPosition,
                    marginLeft: "0px",
                    marginRight: "0px",
                    borderRadius: "var(--radius)"
                }}>

                    {(IsLeo(window.theme)) &&
                        <Grid direction="column" container alignItems="center" sx={{
                            marginTop: "5px",
                            padding: ""
                        }}>
                            <Typography sx={mixMaxFlexStyle}>
                                {mixMaxFlex}
                            </Typography>
                            <Typography sx={{
                                fontSize: "32px",
                                fontFamily: mixMaxFlexStyle.fontFamily as string,
                                color: mixMaxFlexStyle.color as string,
                                fontWeight: "800",
                                marginTop: theme === themeC.Hajper ? "-5px" : "-10px"
                            }}>
                                {number}
                            </Typography>
                        </Grid>
                    }

                    {IsVideo(window.theme) &&
                        <Grid direction="column" container alignItems="center" sx={{ padding: "5px", marginTop: "3px" }}>
                            <Typography sx={{
                                fontSize: "13px",
                                fontFamily: fontFamily,
                                color: minMaxFlexTextColor,
                                fontWeight: window.theme === themeC.Kung ? "700" : "400",
                                textTransform: (window.theme === themeC.Video) ? "none" : "uppercase",
                                marginTop: "0px"
                            }}>
                                {mixMaxFlex}
                            </Typography>
                            <Box
                                sx={{
                                    backgroundImage: numberImage,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    height: numberBackgroundHeight,
                                    width: numberBackgroundWidth,
                                    marginTop: window.theme === themeC.Video ? "-8px" : "0px"
                                }}
                            >
                                {numberIcon}
                            </Box>

                        </Grid>
                    }

                    {(UsePoolXLogoInRoundList(window.theme)) &&
                        <Grid direction="column" container alignItems="center">
                            <Box
                                sx={{
                                    backgroundImage: numberImage,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    padding: "20px"
                                }}
                            >{icon}
                            </Box>
                        </Grid>
                    }

                </Grid>
            </Grid>
            )}

            <Grid container sx={{
                flexGrow: 1, overflow: 'hidden',
                maxWidth: isSmallScreen ? '80%' : "auto"
            }} direction='column' alignItems='center' justifyContent='center'>
                <Typography sx={smallText}>{dateString}</Typography>
                <Typography sx={smallTitleUpper} >{syndicate.name}</Typography>
                {syndicate.agentUserName !== undefined && <Typography sx={smallText}>{syndicate.agentUserName}</Typography>}
            </Grid>

            {!isSmallScreen &&
                <>
                    {syndicate.couponHidden && !syndicate.showDraftCoupon ?
                        <Grid container sx={{ maxWidth: "150px" }} direction='column' alignItems='center' justifyContent='center'>
                            <Typography sx={smallText}>{t('total_cost') + ': '}</Typography>
                            <Typography sx={smallTextValues}>{nf.format((Number(syndicate.stakePerShare.amount) + Number(syndicate.agentFeePerShare.amount)) * syndicate.targetNShares)}</Typography>
                        </Grid>
                        :
                        <Grid container sx={{ maxWidth: "150px" }} direction='column' alignItems='center' justifyContent='center'>
                            <Typography sx={smallText}>{t('number_of_rows') + ': '}</Typography>
                            <Typography sx={smallTextValues}>{syndicate.coupon.totalRows}</Typography>
                        </Grid>
                    }
                    <Grid container sx={{ maxWidth: "100px" }} direction='column' alignItems='center' justifyContent='center'>
                        <Typography sx={smallText}>{t('shares') + ': '}</Typography>
                        {syndicate.nSharesHidden ?
                            <Typography sx={smallTextValues}>{syndicate.targetNShares}</Typography>
                            :
                            <Typography sx={smallTextValues}>{'(' + syndicate.nShares + '/' + syndicate.targetNShares + ')'}</Typography>
                        }
                    </Grid>
                </>
            }
            <Grid container sx={{ maxWidth: isSmallScreen ? "100px" : "150px", minWidth: isSmallScreen ? "100px" : "150px" }} direction='column' alignItems='center' justifyContent='center'>
                <Typography sx={stakeStyle}>{formattedStakePerShare}</Typography>
            </Grid>

        </Grid>
    );

}

export default SyndicateListItem;
